let MaskInventoryData = {
  itemId: "",
  maskName: "",
  size: "",
  price: "",
  imageUrl: "",
  available: "",
  borrowed: 0,
  rented: 0,
  createdBy: "",
  createdAt: "",
  center: "",
};

let MaskHistoryData = {
  activity: "",
  amount: "",
  status: "",
  datetime: "",
  HN: "",
  firstname: "",
  lastname: "",
  mobile: "",
  dueDate: "",
  rentalPeriod: "",
  price: "",
  note: "",
  createdBy: "",
  isReturned: false,
  maskName: "",
  size: "",
  inventoryDocId: "",
  center: "",
};

const MaskActivityOptions = ["Borrow", "Rent", "Return"];

const MaskSizes = ["S", "M", "L", "Free Size"];

const Masks = [
  "Nasal Mask ResComf",
  "Full Face Mask ResComf",
  "Nasal Mask AirFit N20",
  "Nasal Mask AirFit N30",
  "Nasal Mask AirFit N30i",
  "Full Face Mask AirFit F20",
  "Full Face Mask AirTouch F20",
  "Nasal Pillow AirFit P10",
  "Nasal Pillow AirFit P30i",
  "Nasal Mask Wizard 310",
  "Full Face Mask Wizard 320",
  "Topson Full Face FM50 Mask",
  "Topson Nasal NM40 Mask",
  "Topson Nasal NM50 Mask",
  "VentMed Nasal Pillow Mark",
  "Philips Wisp Nasal Mask",
  "Philips Pico Nasal Mask",
  "Philips Amara Gel Full Face Mask",
];

const RentalPeriods = [
  "1 week",
  "2 weeks",
  "1 month",
  "3 months",
  "6 months",
  "1 year",
];

const TransactionStatusOptions = ["Active", "Returned"];

export {
  MaskInventoryData,
  MaskHistoryData,
  MaskActivityOptions,
  MaskSizes,
  Masks,
  RentalPeriods,
  TransactionStatusOptions,
};
